/* eslint-disable no-unused-vars */

import db from "../db/db";
import API from "../utils/API";

export const AgentUtils = {
  isAndroid,
  getBaseUrl,
  getDeviceId,
  getDeviceSetting,
  getTerminalBean,
  getWindowDimensions,
  getWindowDimensionsExAppBars,
  getTerminalBeanFromId,
  getWindowDimensionsExAppBarsDualMode,
};

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;

  return {
    width,
    height,
  };
}

function getWindowDimensionsExAppBars() {
  const { innerWidth: width, innerHeight: height } = window;

  let appBarHeight = 112;
  if (width >= 600) {
    appBarHeight = 128;
  }
  let w = width;
  let h = height - appBarHeight;
  return {
    w,
    h,
  };
}

function getWindowDimensionsExAppBarsDualMode(mode) {
  if (mode === "desktop-pos") {
    const { innerWidth: width, innerHeight: height } = window;

    let appBarHeight = 56;

    let w = width;
    let h = height - appBarHeight;
    return {
      w,
      h,
    };
  } else {
    const { innerWidth: width, innerHeight: height } = window;

    let appBarHeight = 112;
    if (width >= 600) {
      appBarHeight = 128;
    }
    let w = width;
    let h = height - appBarHeight;
    return {
      w,
      h,
    };
  }
}

function isAndroid() {
  if (
    window.JSBridge &&
    typeof window.JSBridge !== "undefined" &&
    window.JSBridge !== null
  )
    return true;
  return false;
}

async function getDeviceId() {
  try {
    if (isAndroid()) {
      return window.JSBridge.getDeviceId();
    } else {
      let { data } = await API.get("http://localhost:3337/agent/device/info");
      return data.deviceId;
    }
  } catch (e) {
    return null;
  }
}

async function getBaseUrl() {
  try {
    if (isAndroid()) {
      return window.JSBridge.getBaseUrl();
    } else {
      return window.location.origin;
    }
  } catch (e) {
    return null;
  }
}

async function getDeviceSetting(deviceId) {
  let dbData = await db.setting
    .where("sKey")
    .equals("device_" + deviceId)
    .toArray();
  if (dbData.length == 0) {
    return null;
  } else {
    return JSON.parse(dbData.sValue);
  }
}

async function getTerminalBean(deviceId) {
  let dbData = await db.terminal.toArray();
  for (let t of dbData) {
    if (t.deviceId == deviceId) {
      return t;
    }
  }
  return null;
}

async function getTerminalBeanFromId(id) {
  let dbData = await db.terminal.toArray();
  for (let t of dbData) {
    if (t.id == id) {
      return t;
    }
  }
  return null;
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
